export default {
  keywordHistoryResults: [],
  keywordHistoryResult: undefined,
};
